import { API_DOMAIN } from '@constants';
import type { LibApiType } from '@types';
import axios from '@utils/axios';
import { teamConfig } from '../../../utils/teamConfig';

interface Params {
  name: string;
  url: string;
  size: number;
  duration?: number;
  albumId: number;
  type: LibApiType;
  frame?: number;
  suffix?: string;
  subtitle?: string;
}

/** 返回素材库id */
const addToLib = async (requestData: Params): Promise<number> => {
  const url = teamConfig(
    `${API_DOMAIN}/member/my/media`,
    `${API_DOMAIN}/team/app/tours/media`
  );
  const { mediaId } = await axios.post<{ mediaId: number }>(url, requestData);
  return mediaId;
};

export default addToLib;
